<template>
  <form class=" mt-2" @submit.prevent="save">
    <div class="row">
      <div class="col-md-6">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">First Name<span style="color: red;">*</span>:</label>
          <input type="text" class="form-control" v-model="user.first_name" placeholder="First Name" />
        </div>
      </div>
      <div class="col-md-6">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">Last Name<span style="color: red;">*</span>:</label>
          <input type="text" class="form-control" v-model="user.last_name" placeholder="Last Name" />
        </div>
      </div>
      <div class="col-md-6">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">Username<span style="color: red;">*</span>:</label>
          <input type="text" class="form-control" v-model="user.user_name" placeholder="Username" />
        </div>
      </div>
      <div class="col-md-6">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">Email<span style="color: red;">*</span>:</label>
          <input type="email" class="form-control" v-model="user.email" placeholder="Email" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <!-- title input -->
        <div class="form-group">
          <label class="label-form">Password<span style="color: red;">*</span>:</label>
          <input type="password" class="form-control" v-model="user.password" placeholder="Password" />
          <p v-if="user.password.length >= 1 && user.password.length < 8 "><span class="text-danger">Password must be
              atleast 8 characters</span></p>
        </div>
      </div>
      <!-- <div class="col-md-6">
        title input 
        <div class="form-group">
          <label class="label-form">Phone:</label>
          <input type="text" class="form-control" v-model="user.phone" placeholder="Phone" />
        </div>
      </div> -->
      <div class="col-md-6">
        <!-- title input -->
        <div class="form-group" v-if=" $can('admin_users_update_usertype')">
          <label class="label-form">User Type<span style="color: red;">*</span>:</label>
          <select style="padding:7px 10px" v-model="user.role_id" class="form-control" placeholder="Select User Type" @change="selectType">
            <option value=""></option>
            <option value=1 v-if=" $can('admin_users_update_usertype_admin')">Admin</option>
            <option value=2 v-if=" $can('admin_users_update_usertype_crm')" >CRM</option>
            <option value=3 v-if=" $can('admin_users_update_usertype_editor')">Editor</option>
            <option value=4 v-if=" $can('admin_users_update_usertype_support')">Support</option>
            <option value=5 v-if=" $can('admin_users_update_usertype_dataentry')">Data Entry</option>
            <option value=6 v-if=" $can('admin_users_update_usertype_marketing')">Digital Marketing</option>
            <option value=7 v-if=" $can('admin_users_update_usertype_adh')">ADH</option>
            <option value=8 v-if=" $can('admin_users_update_usertype_lead')">Development Lead</option>
            <option value=9 v-if=" $can('admin_users_update_usertype_developer')">Developer</option>
            <option value=10 v-if=" $can('admin_users_update_usertype_csm')">CSM</option>
            <option value=11 v-if=" $can('admin_users_update_usertype_adhhelper')">ADH Helper</option>
            <option value=12 v-if=" $can('admin_users_update_usertype_qa')">QA</option>
            <option value=13 v-if=" $can('admin_users_update_usertype_designer')">Designer</option>
            
          </select>
          
        </div>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-sm-12 col-md-6" >
            <div class="form-group">
              <label  class="label-form">Software <span style="color: red;">*</span>:</label>
              <multiselect @input="selectedProduct" :options="developmentDepartments" :multiple="true" :taggable="true" :close-on-select="false" :clear-on-select="false" 
              :internal-search="false" :selectedLabel="null" :deselectLabel="null" :selectLabel="null" :allow-empty="true" v-model="selected_product"
                label="name" track-by="id" style="font-size:12px !important">
              </multiselect>
            </div>
        </div>
    </div> -->
    <div class="row">
      <div v-if="[7,8,9,11].includes(user.role_id) || show_team_field" class="col-sm-12 col-md-6" >
          <div class="form-group">
            <label   class="label-form">Team<span style="color: red">*</span>:</label>
            <multiselect v-if="role == 7" :multiple="true" :options="adhteams"   :selectedLabel="null" :deselectLabel="null" :allow-empty="true"
                        v-model="user.team" :selectLabel="null" :internal-search="true" label="name" track-by="id" placeholder="Team">
            </multiselect>

              <multiselect v-else :options="teams" :multiple="true" :selectedLabel="null" :deselectLabel="null" :allow-empty="true"
                v-model="user.team" :selectLabel="null" :internal-search="true" label="name" track-by="id" placeholder="Team">
              </multiselect>
          </div>
        </div>
      <div class="col-sm-12 col-md-6" >
            <div class="form-group">
              <label  class="label-form">Software <span style="color: red;">*</span>:</label>
              <multiselect @input="selectedProduct" :options="products" :multiple="true" :taggable="true" :close-on-select="false" :clear-on-select="false" 
              :internal-search="false" :selectedLabel="null" :deselectLabel="null" :selectLabel="null" :allow-empty="true" v-model="selected_product"
                label="name" track-by="id" style="font-size:12px !important">
              </multiselect>
            </div>
        </div>
        
        <div v-if="set_zoom_credentials" class="col-sm-12 col-md-6" >
            <div class="form-group">
              <label  class="label-form"> Zoom Cliend Id:</label>
              <input type="text" class="form-control" v-model="user.client_id" placeholder="Zoom Client Id" />
            </div>
        </div>
      </div>
      <div v-if="set_zoom_credentials"  class="row">
        <div class="col-sm-12 col-md-6" >
            <div class="form-group">
              <label  class="label-form"> Zoom Client Secret:</label>
              <input type="text" class="form-control" v-model="user.client_secret" placeholder="Zoom Client Secret" />
            </div>
        </div>
        <div v-if="set_zoom_credentials" class="col-sm-12 col-md-6" >
          <div class="form-group">
            <label  class="label-form"> Zoom Account Id:</label>
            <input type="text" class="form-control" v-model="user.account_id" placeholder="Zoom Account Id" />
          </div>
      </div>
      </div>
    <div class="row">
      <div class="col-md-12">
        <!-- buttons -->
        <div class="form-footer text-right">
          <button type="button" class="btn btn-secondary" data-dismiss="modal"
            @click="close_modal">Close</button>
          <button type="submit" class="btn btn-default ml-1" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" >
            <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
            Save
          </button>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import axios from 'axios';
  import Multiselect from "vue-multiselect";
  import { mapGetters } from 'vuex';
  export default {
     components: {
      Multiselect
    },
    data: function () {
      return {
        selected: '',
        selected_product: '',
        products: '',
        products_status: [],
        user: this.get_empty_user_obj(),
        isMiniLoading: false,
        type: "",
        search: "",
        set_zoom_credentials: false,
        developmentDepartments: this.$store.dispatch("tasks/getDepartmentList"),
        show_team_field:false,
        adhteams:{},
        user_id:localStorage.getItem('admin_id'),
        role: JSON.parse(localStorage.getItem("role")),
        userAssignedProduct :localStorage.getItem("user_product"),
      };
    },
    computed:{
      ...mapGetters('persist', ['teams']),
      filteredTeams() {
                return this.teams.filter(team => 
                    team.team_developer.some(developer => developer.user_id == this.user_id)
             );

        }
    },
    created: function () {
       this.products = this.$store.getters['persist/availableProducts'];
        this.products = this.products.filter(product =>
         this.userAssignedProduct.includes(product.id)
        );
      this.get_empty_user_obj();    
    },
    watch:{  
      filteredTeams: {
                handler(newFilteredTeams) {
                     this.adhteams = newFilteredTeams;
                },
                immediate: true
            },
          },
    methods: {
      save() {
        this.isMiniLoading = true;
        let user_name = this.user.user_name;
        let usr_first_name = this.user.first_name;
        let usr_last_name = this.user.last_name;
        let usr_email = this.user.email;
        let usr_password = this.user.password;
        let usr_type = this.user.role_id;
        let selected_product = this.products_status;

        let team= (this.user.team.length > 0 && ([7,8,9,11].includes(usr_type)) ||  !([7,8,9,11].includes(usr_type)))? this.user.team.map(({ id }) => id): [];
        if (usr_password != '' && user_name.length != '' && usr_first_name.length > 1 != '' && usr_last_name.length != '' && usr_email != '' && usr_type != ''&& selected_product != '' && ((['7','8','9','11'].includes(usr_type) && team.length>0 )|| !['7','8','9','11'].includes(usr_type))) {
          if (usr_password.length < 8) {
            this.isMiniLoading = false;
            this.$toast.error('The password must be atleast 8 characters');
          } else {
             const permission = {
              headers: {
                'X-Permission': 'admin_users_create' 
              }
            };
               
            axios.post('/admin/users/create-admin-user', { user_name: user_name, first_name: usr_first_name, last_name: usr_last_name, email: usr_email, password: usr_password, role_id: usr_type,product:selected_product,client_id:this.user.client_id,client_secret:this.user.client_secret,account_id:this.user.account_id,teams: team },permission)
              .then(() => {
                this.isMiniLoading = false;
                window.$('#modal').modal('hide');
                this.$store.dispatch('users/getAdminUsers',[]);
                this.$toast.success('User Added Successfully');
                this.user = this.get_empty_user_obj();
                this.set_zoom_credentials = false;
              })
              .catch(() => {
                this.isMiniLoading = false;
                this.$toast.error('Username or Eamil already exist');
              });
          }

        } else {
          this.isMiniLoading = false;
          this.$toast.warning('Please Fill Requireds Fields');
        }


      },
      get_empty_user_obj() {
        return { user_name: '', password: '', first_name: '', last_name: '', email: '', role_id: '',team:[], client_id: '', client_secret: '',account_id: '' };
      },
      close_modal() {
        this.$store.dispatch('modal/close', {});
        this.user = this.get_empty_user_obj();
        this.set_zoom_credentials = false;
      },
      selectedProduct(){
        let product = [];
        this.selected_product.forEach(key => {
          product.push(key.id)
        });
        this.products_status = product;
      },
      selectType(){
        if(this.user.role_id != 7 && this.user.role_id != 8 && this.user.role_id != 9 && this.user.role_id != 11){
          this.team = [];
          this.show_team_field = false;
        }else{
          this.team = [];
          this.show_team_field = true;
        }
        this.set_zoom_credentials = (this.user.role_id == 4 || this.user.role_id == 10) ? true : false;
      }
    }

  }
</script> 

<style scoped>
  span.error {
    display: block;
    color: red;
    margin-top: 5px;
  }

  .field {
    margin-top: 20px;
  }
  
</style>
<style >
  .multiselect .multiselect__tags {
    border-radius: 0.25rem;
  }
</style>